import { createApp } from 'vue'
import i18n from '~/src/plugins/i18n'
import { api } from '~/src/services/axios'
import posthog from '~/src/plugins/posthog'
import TourOptInModal from '../../../src/tour_guiado/components/TourOptInModal.vue'
import TourBuilderPanel from '../../../src/tour_guiado/components/TourBuilderPanel.vue'
import ToursGuiadosAdminIndex from '../../../src/tour_guiado/components/admin/ToursGuiadosAdminIndex.vue'
import ToursGuiadosAdminEdit from '../../../src/tour_guiado/components/admin/ToursGuiadosAdminEdit.vue'

function idDoDataset(valor) {
  const id = Number(valor)
  return valor && Number.isInteger(id) ? id : null
}

function identificacaoDoMount(elemento) {
  return {
    pessoa_id: idDoDataset(elemento.dataset.pessoaId),
    empresa_id: idDoDataset(elemento.dataset.empresaId)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const optInEl = document.getElementById('tour-opt-in')
  if (optInEl && optInEl.dataset.tourPlayerMontado !== 'true') {
    optInEl.dataset.tourPlayerMontado = 'true'
    const identificacao = identificacaoDoMount(optInEl)
    createApp(TourOptInModal, { identificacao })
      .use(posthog, { defaultParams: identificacao })
      .mount(optInEl)
  }

  const podeGerirTours = document.querySelector('meta[name="pode-gerir-tours"]')?.content === 'true'
  const builderEl = document.getElementById('tour-builder')
  if (builderEl && podeGerirTours) {
    createApp(TourBuilderPanel).mount(builderEl)
  }

  const URL_TOURS = '/tours_guiados'

  const adminIndexEl = document.getElementById('vue-tours-guiados-admin-index')
  if (adminIndexEl) {
    const app = createApp(ToursGuiadosAdminIndex)
    app.use(i18n, { context: 'tours_guiados.admin.index' })
    app.config.globalProperties.$api = api
    app.provide('URL_TOURS', URL_TOURS)
    app.mount(adminIndexEl)
  }

  const adminEditEl = document.getElementById('vue-tours-guiados-admin-edit')
  if (adminEditEl) {
    const tourId = adminEditEl.dataset.tourId
    let dadosIniciais = {}
    try {
      dadosIniciais = JSON.parse(adminEditEl.dataset.tour || '{}')
    } catch (e) {
      console.warn('Falha ao parsear dados iniciais do tour:', e)
      exibe_mensagem_com_status($i18n('tours_guiados.admin.edit.falha_carregar_dados'), 'error')
    }
    const app = createApp(ToursGuiadosAdminEdit, { tourId, dadosIniciais })
    app.use(i18n, { context: 'tours_guiados.admin.edit' })
    app.config.globalProperties.$api = api
    app.provide('URL_TOURS', URL_TOURS)
    app.mount(adminEditEl)
  }
})
